module.exports = __webpack_public_path__ + "static/media/user.8ea7dce6.svg";